import { render } from "./MainProducts.vue?vue&type=template&id=4ff6d948&scoped=true"
import script from "./MainProducts.vue?vue&type=script&lang=js"
export * from "./MainProducts.vue?vue&type=script&lang=js"

import "./MainProducts.vue?vue&type=style&index=0&id=4ff6d948&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff6d948"]])

export default __exports__